import { DIALOG_DATA, Dialog } from '@angular/cdk/dialog';
import { Component, Directive, ElementRef, HostListener, Input, inject } from '@angular/core';

@Component({
  selector: 'img-preview-cmp',
  template: ` <img [src]="data.url" width="600" /> `,
})
export class ImgPreviewCmp {
  readonly data: { url: string } = inject(DIALOG_DATA);
}

@Directive({
  selector: '[hostImgPreview]',
  providers: [ImgPreviewCmp],
})
export class ImgPreviewDirective {
  #imgUrl;

  constructor(private el: ElementRef, private dialog: Dialog) {}

  @HostListener('click', ['$event'])
  onClick(event) {
    this.dialog.open(ImgPreviewCmp, {
      data: { url: this.#imgUrl || this.el.nativeElement.src },
    });
  }

  @Input() set hostImgPreview(url: string) {
    if (url) {
      this.#imgUrl = url;
    }
  }
}
